export const css = {
    root: 'fSe4e7z5',
    toolbar: '_2To5YCD9',
    alphabutton: '_2UUJZtfX',
    numberbutton: '_3o6IahOo',
    searchinput: 'e08ul39w',
    selectedbutton: '_2-Q1PkSw',
    invalidbutton: '_3m9WFNVw',
    result: 'U8EWanNM',
    terms: '_1fgivwnO',
    term: 'AK77uw4I',
    definition: '_2hHwMS67',
    ' _key': 'apic-theme/apic/glossary/glossary'
};
export default css;
